/** Mirrors P2PProviderWorkingHoursDay on the backend. */
export enum P2PProviderWorkingHoursDay {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}
